(function(){
"use strict";
var FQ_DIRTY=false;  // true = quiz in corso, avvisa prima di ricaricare/uscire
// --- rete di sicurezza: se la configurazione manca o è rotta, si va avanti lo stesso ---
if(!window.FQ_CONFIG){
  console.error("FQ: configurazione mancante o con errore di sintassi. Uso i valori di riserva.");
  window.FQ_CONFIG={};
}
var _D={formula:{variantId:0,preis:0,preisVergleich:null,label:"",detail:""},
        bilder:{bereiche:{},kunden:[]},ronaldo:{titel:"",text:""},stimmen:[],
        zutaten:[],faq:[],upsell:[],maxUpsell:3,demo:true};
for(var _k in _D){ if(window.FQ_CONFIG[_k]==null) window.FQ_CONFIG[_k]=_D[_k]; }
if(!window.FQ_CONFIG.bilder.bereiche) window.FQ_CONFIG.bilder.bereiche={};
if(!window.FQ_CONFIG.bilder.kunden)   window.FQ_CONFIG.bilder.kunden=[];

const C=window.FQ_CONFIG,R=document.getElementById("fq"),$=s=>R?R.querySelector(s):null;
if(!R){ console.error("FQ: contenitore #fq non trovato."); return; }
const IMG=C.bilder||{};

/* ---------- DOSE ---------- */
function jar(){
  if(IMG.produkt) return `<img src="${IMG.produkt}" alt="Your Personal Formula">`;
  let g="";
  for(let i=0;i<130;i++){
    const x=92+Math.random()*136,y=96+Math.random()*30,r=1.5+Math.random()*2.2;
    const c=["#e8a33d","#d9743a","#f0d9a8","#c9542f","#efe3c4"][Math.floor(Math.random()*5)];
    g+=`<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="${c}" opacity="${(.6+Math.random()*.4).toFixed(2)}"/>`;
  }
  return `<svg viewBox="0 0 320 360" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="jb" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stop-color="#3b3193"/><stop offset="26%" stop-color="#6155e0"/>
        <stop offset="62%" stop-color="#8b7dff"/><stop offset="100%" stop-color="#3f3499"/></linearGradient>
      <linearGradient id="jl" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stop-color="#4a3fc4"/><stop offset="45%" stop-color="#7a6cf0"/><stop offset="100%" stop-color="#453ab0"/></linearGradient>
      <clipPath id="jc"><rect x="88" y="92" width="144" height="40"/></clipPath>
    </defs>
    <ellipse cx="160" cy="336" rx="86" ry="12" fill="#0d1024" opacity=".13"/>
    <path d="M88 112 h144 v186 a22 22 0 0 1 -22 22 h-100 a22 22 0 0 1 -22 -22 z" fill="url(#jb)"/>
    <ellipse cx="160" cy="112" rx="72" ry="20" fill="#241d6b"/>
    <g clip-path="url(#jc)"><ellipse cx="160" cy="112" rx="66" ry="17" fill="#1a1550"/>${g}</g>
    <rect x="82" y="74" width="156" height="34" rx="10" fill="url(#jl)"/>
    <rect x="82" y="74" width="156" height="8" rx="4" fill="#fff" opacity=".18"/>
    <rect x="104" y="176" width="112" height="82" rx="8" fill="#fff" opacity=".93"/>
    <text x="160" y="200" text-anchor="middle" font-family="Sora,sans-serif" font-size="13" font-weight="700" fill="#171a33">DEINE</text>
    <text x="160" y="219" text-anchor="middle" font-family="Sora,sans-serif" font-size="13" font-weight="700" fill="#171a33">FORMEL</text>
    <line x1="120" y1="228" x2="200" y2="228" stroke="#d8dce8"/>
    <text x="160" y="245" text-anchor="middle" font-family="Azeret Mono,monospace" font-size="6.5" fill="#5d6382" letter-spacing="1.2">30 DAYS · 2 SCOOPS</text>
    <rect x="88" y="112" width="16" height="208" fill="#fff" opacity=".10"/>
  </svg>`;
}
$("#fq-jar1").innerHTML=(IMG.hero?`<img src="${IMG.hero}" alt="Your Personal Formula">`:jar())
  +`<div class="fq-scoops">Usage<b>2 scoops / day</b></div>`;

/* ---------- BILD-SLOTS ---------- */
function slot(id,url,ph){
  const el=$(id); if(!el) return;
  el.innerHTML = url ? `<img src="${url}" alt="">` : `<span class="ph">${ph}</span>`;
}
slot("#fq-im-granulat", IMG.granulat, "Bild: Granulate");
slot("#fq-im-bewertung", IMG.bewertung, "Bild: Wellness-Check");
slot("#fq-im-aufnahme",  IMG.aufnahme,  "Bild: Aufnahme");
slot("#fq-im-qualitaet", IMG.qualitaet, "Image: Quality");
if(IMG.anwendung){const s=$("#fq-step4");
  if(s) s.querySelector(".ic").outerHTML=`<img src="${IMG.anwendung}" alt="Einnahme">`;}

/* ---------- ZUTATEN-LAUFBAND ---------- */
(function(){
  const z=(C.zutaten||[]);
  const chip=x=>`<span class="fq-z">${x.bild?`<img src="${x.bild}" alt="">`:`<i></i>`}${x.name}</span>`;
  $("#fq-track").innerHTML = z.map(chip).join("") + z.map(chip).join("");  // duplicated for seamless loop
})();

/* ---------- VIER BEREICHE ---------- */
const BEREICHE=[
 {k:"haut", tab:"Beauty & Wellbeing", h:"Beauty and wellbeing",
  p:"For anyone who wants to feel good in their skin — and show it.",
  b:["Contributes to the maintenance of normal skin","Contributes to the maintenance of normal hair and nails",
     "Contributes to normal collagen formation","Helps protect cells from oxidative stress"]},
 {k:"kraft", tab:"Sport & Performance", h:"Sport and performance",
  p:"For active people who want to support their physical performance through nutrition.",
  b:["Contributes to normal muscle function","Contributes to normal energy metabolism",
     "Helps reduce tiredness and fatigue","Contributes to the maintenance of normal bones"]},
 {k:"geist", tab:"Cognitive Function", h:"Cognitive and psychological function",
  p:"For anyone who values focus and mental clarity day to day.",
  b:["Contributes to normal nervous system function","Contributes to normal cognitive function",
     "Contributes to normal psychological function"]},
 {k:"altern", tab:"Long-term Wellbeing", h:"Long-term wellbeing",
  p:"For anyone thinking about their whole body and the years ahead.",
  b:["Contributes to the maintenance of normal bones","Contributes to normal immune system function",
     "Contributes to normal heart function","Helps protect cells from oxidative stress"]}
];
function bereich(i){
  const b=BEREICHE[i];
  const url=(IMG.bereiche||{})[b.k];
  $("#fq-tabs").querySelectorAll(".fq-tab").forEach((t,j)=>t.classList.toggle("on",j===i));
  $("#fq-panel").innerHTML=`<div class="fq-panel">
    <div class="fq-pimg">${url?`<img src="${url}" alt="">`:`<span class="ph">Bild: ${b.tab}</span>`}</div>
    <div><h3>${b.h}</h3><p>${b.p}</p>
      <ul class="fq-bl">${b.b.map(x=>`<li>${x}</li>`).join("")}</ul>
      <button class="fq-btn" data-a="start">Meine Formel erstellen</button>
    </div></div>`;
}
$("#fq-tabs").innerHTML=BEREICHE.map((b,i)=>`<button class="fq-tab" data-b="${i}">${b.tab}</button>`).join("");
$("#fq-tabs").querySelectorAll(".fq-tab").forEach((t,i)=>t.addEventListener("click",()=>bereich(i)));
bereich(0);

/* ---------- RONALDO (only if filled in config) ---------- */
(function(){
  const r=C.ronaldo||{};
  if(!r.text || !r.text.trim()) return;
  $("#fq-ron-sec").style.display="block";
  $("#fq-ron-t").textContent=r.titel||"";
  $("#fq-ron-p").textContent=r.text;
  $("#fq-ron-img").innerHTML=IMG.ronaldo?`<img src="${IMG.ronaldo}" alt="">`:"";
})();

/* ---------- KUNDEN (nur wenn Fotos oder Stimmen vorhanden) ---------- */
(function(){
  const fotos=IMG.kunden||[], stimmen=C.stimmen||[];
  if(!fotos.length && !stimmen.length) return;
  $("#fq-kunden-sec").style.display="block";
  if(fotos.length){
    const im=u=>`<img src="${u}" alt="">`;
    $("#fq-ktrack").innerHTML=fotos.map(im).join("")+fotos.map(im).join("");
  } else { $("#fq-ktrack").parentElement.style.display="none"; }
  $("#fq-stimmen").innerHTML=stimmen.map(s=>
    `<div class="fq-stimme"><p>„${s.text}"</p>
     <div class="who">${s.bild?`<img src="${s.bild}" alt="">`:""}<span>${s.name}</span></div></div>`).join("");
})();

/* ---------- FAQ ---------- */
(function(){
  const f=C.faq||[];
  $("#fq-faq").innerHTML=f.map((x,i)=>
    `<div class="fq-fi" data-i="${i}">
       <button class="fq-fq" type="button"><span>${x.f}</span><span class="x">+</span></button>
       <div class="fq-fa"><p>${x.a}</p></div>
     </div>`).join("");
  $("#fq-faq").querySelectorAll(".fq-fq").forEach(btn=>btn.addEventListener("click",()=>{
    const it=btn.parentElement;
    const wasOpen=it.classList.contains("on");
    $("#fq-faq").querySelectorAll(".fq-fi").forEach(x=>x.classList.remove("on"));
    if(!wasOpen) it.classList.add("on");
  }));
})();

/* ---------- DIE 7 BEREICHE ---------- */
const AREE={
 energie:{n:"Energy",s:"Energy",d:"Iron, magnesium and B-vitamins for the dips through your day.",
  nutri:[["Vitamin B12","Red blood cells and energy"],["Iron","Oxygen transport"],["Magnesium","Muscles, sleep and energy"],["Vitamin B6","Mood and nervous system"],["Pantothenic acid","Energy metabolism"]]},
 geist:{n:"Cognitive Function",s:"Mind",d:"Support for focus, memory and clarity.",
  nutri:[["Omega-3 DHA","Brain structure"],["Vitamin B6","Neurotransmitters"],["Iodine","Thyroid hormone"],["Zinc","Cognitive function"]]},
 kraft:{n:"Muscle Strength",s:"Strength",d:"Protein, magnesium and minerals for training and recovery.",
  nutri:[["Magnesium","Muscle contraction"],["Vitamin D3","Muscles and hormones"],["Zinc","Recovery"],["Potassium","Electrolyte balance"]]},
 knochen:{n:"Bones",s:"Bones",d:"Calcium, vitamin D3 and K2 for bone density.",
  nutri:[["Calcium","Bones and teeth"],["Vitamin D3","Calcium absorption"],["Vitamin K2","Binds calcium in bone"],["Manganese","Connective tissue"]]},
 herz:{n:"Heart",s:"Heart",d:"Omega-3 and antioxidants for the cardiovascular system.",
  nutri:[["Omega-3 EPA","Heart function"],["Vitamin K2","Arterial elasticity"],["Folate","DNA and red blood cells"],["Niacin","Cholesterol levels"]]},
 haut:{n:"Skin & Hair",s:"Skin",d:"Biotin, zinc and vitamin C for tissue renewal.",
  nutri:[["Biotin","Hair, skin and nails"],["Zinc","Cell renewal"],["Vitamin C","Collagen formation"],["Vitamin E","Skin protection"],["Vitamin A","Tissue renewal"]]},
 altern:{n:"Healthy Ageing",s:"Ageing",d:"Antioxidants and cell protection over time.",
  nutri:[["Selenium","Antioxidant and thyroid"],["Vitamin E","Cell protection"],["Coenzyme Q10","Cellular energy"],["Lutein","Eyes and vision"],["Vitamin C","Immunity and collagen"]]}
};
const K=Object.keys(AREE);

/* ---------- DIE 25 FRAGEN ---------- */
const Q=[
 {s:"Profile",t:"What's your name?",h:"Just to label your formula.",type:"text",lab:"Name",ph:"Your name"},
 {s:"Profile",t:"When were you born?",type:"date",lab:"Date of birth",
  sc:v=>{const a=new Date().getFullYear()-new Date(v).getFullYear();
         return a>=50?{knochen:3,altern:3,herz:2}:a>=35?{altern:2,herz:1}:{}}},
 {s:"Profile",t:"Biological sex",h:"It changes your needs for iron, calcium and other nutrients.",type:"ch",lab:"Sex",two:1,
  o:[{t:"Female",p:{knochen:2,haut:1}},{t:"Male",p:{kraft:1}}]},
 {s:"Profile",t:"How tall are you?",type:"num",unit:"cm",min:120,max:230,lab:"Height",sc:()=>({})},
 {s:"Profile",t:"How much do you weigh?",type:"num",unit:"kg",min:35,max:250,lab:"Weight",sc:()=>({})},

 {s:"Goals",t:"Which two areas would you most like to support?",h:"Choose exactly two.",type:"multi",need:2,lab:"Priority areas",
  o:[{t:"Skin and hair",p:{haut:6}},{t:"Cognitive function",p:{geist:6}},{t:"Energy and tiredness",p:{energie:6}},
     {t:"Healthy ageing",p:{altern:6}},{t:"Heart",p:{herz:6}},{t:"Bones",p:{knochen:6}},{t:"Muscle strength",p:{kraft:6}}]},
 {s:"Goals",t:"What's your current fitness goal?",type:"ch",lab:"Fitness goal",two:1,
  o:[{t:"Build muscle",p:{kraft:5}},{t:"Lose weight",p:{energie:3,altern:2}},
     {t:"Improve endurance",p:{energie:4,herz:3}},{t:"Support general wellbeing",p:{altern:3,energie:2}}]},

 {s:"Diet",t:"Do you follow any of these diets?",h:"Select all that apply.",type:"multi",lab:"Diet",two:1,
  o:[{t:"Vegetarian",p:{energie:3,kraft:2}},{t:"Vegan",p:{energie:5,kraft:3,knochen:2,geist:2}},
     {t:"Pescatarian",p:{herz:1}},{t:"Gluten-free",p:{}},{t:"Lactose-free",p:{knochen:2}},
     {t:"Low-carb or keto",p:{energie:1}},{t:"No particular diet",p:{},x:1}]},
 {s:"Diet",t:"How often do you eat red meat?",type:"ch",lab:"Red meat",two:1,
  o:[{t:"At least 3 times a week",p:{herz:1}},{t:"1–2 times a week",p:{}},
     {t:"A few times a month",p:{energie:2}},{t:"Never",p:{energie:4,kraft:1}}]},
 {s:"Diet",t:"And fish or seafood?",type:"ch",lab:"Fish",two:1,
  o:[{t:"At least 3 times a week",p:{}},{t:"1–2 times a week",p:{herz:1}},
     {t:"A few times a month",p:{herz:3,geist:2}},{t:"Never",p:{herz:5,geist:4}}]},
 {s:"Diet",t:"How much dairy per day?",type:"ch",lab:"Dairy",two:1,
  o:[{t:"At least 3 a day",p:{}},{t:"1–2 a day",p:{}},{t:"A few times a month",p:{knochen:3}},{t:"Never",p:{knochen:5}}]},
 {s:"Diet",t:"How many portions of fruit per day?",type:"ch",lab:"Fruit",two:1,
  o:[{t:"At least 3 a day",p:{}},{t:"1–2 a day",p:{altern:1}},
     {t:"A few times a month",p:{altern:3,haut:2}},{t:"Never",p:{altern:5,haut:3}}]},
 {s:"Diet",t:"And how many portions of vegetables?",h:"Salads and soups count too.",type:"ch",lab:"Vegetables",two:1,
  o:[{t:"At least 3 a day",p:{}},{t:"1–2 a day",p:{altern:1}},
     {t:"A few times a month",p:{altern:3,energie:2}},{t:"Never",p:{altern:5,energie:3}}]},
 {s:"Diet",t:"How many protein portions per day?",h:"Meat, fish, eggs, pulses or protein shakes.",type:"ch",lab:"Protein portions",two:1,
  o:[{t:"1 or fewer",p:{kraft:5,energie:2}},{t:"2 portions",p:{kraft:3}},{t:"3 portions",p:{}},
     {t:"4 portions",p:{}},{t:"5 portions",p:{}},{t:"6 or more",p:{}}]},
 {s:"Diet",t:"Which meal do you eat at a set time?",h:"We use it to align your nutrition window.",type:"ch",lab:"Fixed meal",two:1,
  o:[{t:"Breakfast",p:{}},{t:"Dinner",p:{}}]},
 {s:"Diet",t:"How many caffeinated drinks per day?",type:"ch",lab:"Caffeine",two:1,
  o:[{t:"At least 3 a day",p:{energie:3}},{t:"1–2 a day",p:{energie:1}},{t:"A few times a month",p:{}},{t:"Never",p:{}}]},
 {s:"Diet",t:"How much fluid do you drink daily?",h:"Water, tea, coffee, milk, juices. One glass = 250 ml.",type:"ch",lab:"Fluids",two:1,
  o:[{t:"Fewer than 4 glasses",p:{energie:3,haut:3}},{t:"5 glasses",p:{energie:2,haut:2}},{t:"6 glasses",p:{haut:1}},
     {t:"7 glasses",p:{}},{t:"8 glasses",p:{}},{t:"9 glasses",p:{}},{t:"10 glasses",p:{}},
     {t:"11 glasses",p:{}},{t:"12 or more",p:{}}]},
 {s:"Diet",t:"How many sugary drinks per day?",h:"Fizzy drinks, sweet juices, energy drinks.",type:"ch",lab:"Sugary drinks",two:1,
  o:[{t:"None",p:{}},{t:"1 a day",p:{altern:1}},{t:"2 a day",p:{altern:3}},{t:"3 or more",p:{altern:5,herz:2}}]},

 {s:"Activity",t:"How would you describe your activity level?",type:"ch",lab:"Activity level",two:1,
  o:[{t:"Sedentary or limited mobility",p:{energie:3,knochen:3,herz:2}},
     {t:"Lightly active: desk job, little movement",p:{energie:2,knochen:1}},
     {t:"Moderately active: 1–3 workouts a week",p:{kraft:2}},
     {t:"Very active: training almost daily",p:{kraft:4,energie:2}}]},
 {s:"Activity",t:"What kind of activity do you do?",h:"Select all that apply.",type:"multi",lab:"Type of activity",two:1,
  o:[{t:"Strength training or gym",p:{kraft:4,knochen:2}},{t:"Running, cycling or swimming",p:{herz:3,energie:2}},
     {t:"Team sports",p:{kraft:2,herz:2}},{t:"Yoga, Pilates or stretching",p:{geist:2}},
     {t:"Walking",p:{herz:1}},{t:"No activity",p:{knochen:2,kraft:1},x:1}]},
 {s:"Activity",t:"How many days a week do you train?",type:"ch",lab:"Training days",two:1,
  o:[{t:"I don't train",p:{knochen:2}},{t:"1 day",p:{}},{t:"2 days",p:{kraft:1}},
     {t:"3 days",p:{kraft:2}},{t:"4 days",p:{kraft:3}},{t:"5 or more",p:{kraft:4,energie:2}}]},

 {s:"Wellbeing",t:"Do you feel rested after a normal night's sleep?",type:"ch",lab:"Recovery after sleep",two:1,
  o:[{t:"Yes",p:{}},{t:"No",p:{energie:5,geist:2}}]},
 {s:"Wellbeing",t:"Do you feel energetic and alert during the day?",type:"ch",lab:"Energy and alertness",two:1,
  o:[{t:"Yes",p:{}},{t:"No",p:{energie:5,geist:3}}]},
 {s:"Wellbeing",t:"What should your formula support?",h:"Select all that apply.",type:"multi",lab:"Desired support",
  o:[{t:"Reduce tiredness and fatigue",p:{energie:5}},{t:"Cope with everyday stress",p:{geist:4,energie:2}},
     {t:"Support normal vision",p:{altern:3,geist:1}},{t:"Strengthen the immune system",p:{altern:3,haut:1}},
     {t:"Improve sleep quality",p:{energie:3,geist:2}},{t:"None of these",p:{},x:1}]},
 {s:"Wellbeing",t:"How are your skin, hair and nails right now?",h:"Select all that apply.",type:"multi",lab:"Skin and hair",two:1,
  o:[{t:"Brittle hair or hair loss",p:{haut:4}},{t:"Dull or dry skin",p:{haut:3}},
     {t:"Brittle nails",p:{haut:3}},{t:"All within normal range",p:{},x:1}]}
];

const SAFE=[
 {t:"Do you have any allergies or intolerances?",h:"Select all that apply. Used to exclude ingredients from your formula.",type:"multi",lab:"Allergies",two:1,
  o:[{t:"Lactose"},{t:"Gluten"},{t:"Nuts"},{t:"Soy"},{t:"Shellfish or fish"},
     {t:"Other — I'll note it in the comments",f:1},{t:"None",x:1}]},
 {t:"Does any of these apply to you?",h:"Select all that apply.",type:"multi",lab:"Medical notes",two:1,
  o:[{t:"I take medication regularly",f:1},{t:"I am pregnant or breastfeeding",f:1},
     {t:"I have an existing medical condition",f:1},{t:"None of these",x:1}]}
];
const ALL=Q.concat(SAFE.map(x=>Object.assign({s:"Safety",extra:1},x)));

/* ---------- ENGINE ---------- */
const st={i:0,a:new Array(ALL.length).fill(null),plan:false,up:new Set()};
const stage=n=>R.querySelectorAll(".fq-stage").forEach(e=>e.classList.toggle("on",e.dataset.s===n));
const CX=150,CY=140,RR=98;
const pt=(i,v)=>{const a=-Math.PI/2+i*2*Math.PI/7,r=14+RR*v;return[CX+r*Math.cos(a),CY+r*Math.sin(a)];};
(function(){let g="";
 [.34,.67,1].forEach(f=>{g+=`<polygon class="fq-ring" points="${K.map((_,i)=>pt(i,f).map(n=>n.toFixed(1)).join(",")).join(" ")}"/>`;});
 K.forEach((k,i)=>{const[x,y]=pt(i,1);g+=`<line class="fq-axis" x1="${CX}" y1="${CY}" x2="${x.toFixed(1)}" y2="${y.toFixed(1)}"/>`;
  const[lx,ly]=pt(i,1.25);
  g+=`<text class="fq-lab" x="${lx.toFixed(1)}" y="${(ly+3).toFixed(1)}" text-anchor="middle">${AREE[k].s.toUpperCase()}</text>`;});
 var _sc=$("#fq-scaffold"); if(_sc) _sc.innerHTML=g;})();

function scores(){const t={};K.forEach(k=>t[k]=0);
 st.a.forEach(a=>{if(!a)return;(a.ps||(a.p?[a.p]:[])).forEach(p=>{for(const k in p)t[k]+=p[k];});});return t;}
function radar(){var poly=$("#fq-poly"); if(!poly) return;
 const t=scores(),m=Math.max(6,...Object.values(t));
 poly.setAttribute("d","M"+K.map((k,i)=>pt(i,.1+.9*(t[k]/m)).map(n=>n.toFixed(1)).join(",")).join("L")+"Z");
 const n=st.a.filter(Boolean).length;
 var rf=$("#fq-rf"); if(rf) rf.textContent=n?n+" answers read":"Waiting for your first answer";}
radar();

function render(){
 const q=ALL[st.i],a=st.a[st.i];
 $("#fq-sec").textContent=q.s;$("#fq-cur").textContent=Math.min(st.i+1,25);
 $("#fq-fill").style.width=(st.i/ALL.length*100)+"%";
 let body="";
 if(q.type==="ch"||q.type==="multi"){
  body=`<div class="fq-opts${q.two?" two":""}">`+q.o.map((o,k)=>{
   const on=q.type==="multi"?(a&&a.ks.includes(k)):(a&&a.k===k);
   return `<button class="fq-opt${on?" sel":""}" data-k="${k}">
    ${q.type==="multi"?`<span class="fq-k box">${on?"✓":"&nbsp;"}</span>`:""}
    <span>${o.t}</span></button>`;}).join("")+`</div>`;
 } else if(q.type==="num"){
  body=`<div class="fq-inrow"><input class="fq-in" type="number" id="fq-x" min="${q.min}" max="${q.max}" value="${a?a.v:""}" placeholder="—"><span class="fq-unit">${q.unit}</span></div>`;
 } else if(q.type==="date"){
  body=`<input class="fq-in" type="date" id="fq-x" value="${a?a.raw:""}">`;
 } else {
  body=`<input class="fq-in" type="text" id="fq-x" value="${a?a.v:""}" placeholder="${q.ph||""}">`;
 }
 const badge=q.type==="multi"?`<span class="fq-badge">${q.need?"Choose exactly "+q.need:"Select multiple"}</span>`:"";
 const num=q.extra?(C.txt&&C.txt.laststep||"Letzter Schritt"):((C.txt&&C.txt.question||"Frage")+" "+String(st.i+1).padStart(2,"0"));
 $("#fq-q").innerHTML=`<div class="fq-qn">${num}</div><h2>${q.t}</h2>${q.h?`<p class="fq-hint">${q.h}</p>`:""}${badge}${body}`;

 if(q.type==="ch"||q.type==="multi"){
  $("#fq-q").querySelectorAll(".fq-opt").forEach(b=>b.addEventListener("click",()=>{
   const k=+b.dataset.k;
   if(q.type==="multi"){
    let ks=(st.a[st.i]&&st.a[st.i].ks)||[];
    if(q.o[k].x){ks=ks.includes(k)?[]:[k];}
    else{ks=ks.filter(x=>!q.o[x].x);
         ks=ks.includes(k)?ks.filter(x=>x!==k):ks.concat(k);
         if(q.need&&ks.length>q.need)ks=ks.slice(-q.need);}
    st.a[st.i]=ks.length?{ks,v:ks.map(x=>q.o[x].t).join(", "),ps:ks.map(x=>q.o[x].p||{}),
      f:ks.some(x=>q.o[x].f),ok:q.need?ks.length===q.need:true}:null;
    render();radar();
    if(q.need&&st.a[st.i]&&st.a[st.i].ok)setTimeout(next,260);
   } else {
    st.a[st.i]={k,v:q.o[k].t,p:q.o[k].p||{},f:!!q.o[k].f};
    render();radar();setTimeout(next,220);
   }
  }));
 } else {
  const x=$("#fq-x");
  x.addEventListener("input",()=>{
   if(q.type==="num"){const v=+x.value;st.a[st.i]=(v>=q.min&&v<=q.max)?{v,p:q.sc(v)}:null;}
   else if(q.type==="date"){st.a[st.i]=x.value?{raw:x.value,v:x.value.split("-").reverse().join("."),p:q.sc(x.value)}:null;}
   else{st.a[st.i]=x.value.trim().length>1?{v:x.value.trim(),p:{}}:null;}
   sync();radar();
  });
  x.focus();
 }
 R.querySelector('[data-a="back"]').style.visibility=st.i===0?"hidden":"visible";
 sync();
}
function sync(){
 const a=st.a[st.i],q=ALL[st.i],ok=a&&(q.type!=="multi"||a.ok);
 const b=R.querySelector('[data-a="next"]');
 b.disabled=!ok;b.textContent=st.i===ALL.length-1?(C.txt&&C.txt.create||"Formel erstellen"):(C.txt&&C.txt.next||"Weiter");
}
function next(){if(st.i<ALL.length-1){st.i++;render();}else analyse();}

function analyse(){
 stage("load");window.scrollTo({top:0});
 let p=0;
 const t=setInterval(()=>{
  p+=Math.random()*7+2;
  if(p>=100){p=100;clearInterval(t);setTimeout(results,450);}
  $("#fq-pc").textContent=Math.floor(p)+"%";
  $("#fq-arc").style.strokeDashoffset=478-(478*p/100);
  $("#fq-lt").textContent=p<35?"Analysing your answers":p<70?"Matching to your needs":"Building your formula";
 },110);
}

const F=C.formula;
const eu=n=>{var w=(C.waehrung||"€");
  if(w==="£"||w==="$") return w+n.toFixed(2);        // simbolo prima, punto decimale (UK/US)
  return n.toFixed(2).replace(".",",")+" "+w;};       // simbolo dopo, virgola (EUR/CHF)
const hasVergleich = F.preisVergleich && F.preisVergleich > F.preis;
const rabatt = hasVergleich ? Math.round((1-F.preis/F.preisVergleich)*100) : 0;

function results(){
 const t=scores(),rank=K.map(k=>({k,v:t[k]})).sort((a,b)=>b.v-a.v);
 st.rank=rank;
 const max=Math.max(1,rank[0].v);
 const name=st.a[0]?st.a[0].v:null;

 $("#fq-jar2").innerHTML=jar();
 $("#fq-title").textContent=name?`${name}, your formula is ready.`:"Your formula is ready.";
 $("#fq-sub").textContent="We've read all 25 answers. These are the areas your formula works on first.";

 $("#fq-top").innerHTML=rank.slice(0,3).map((p,i)=>
  `<div class="fq-card"><div class="r">Priority ${i+1}</div><h3>${AREE[p.k].n}</h3>
   <p>${AREE[p.k].d}</p><div class="fq-m"><i style="width:${Math.max(20,Math.round(p.v/max*100))}%"></i></div></div>`).join("");

 const seen=new Set(),nutri=[];
 rank.slice(0,3).forEach(p=>AREE[p.k].nutri.forEach(([n,d])=>{if(!seen.has(n)){seen.add(n);nutri.push([n,d]);}}));
 $("#fq-nlist").innerHTML=nutri.map(([n,d])=>
  `<div class="fq-n"><span class="g"></span><span><b>${n}</b><span>${d}</span></span></div>`).join("");

 const flag=st.a.some(a=>a&&a.f);
 $("#fq-flag").innerHTML=flag
  ? `<div class="fq-flag"><b>We'll be in touch before your formula is made.</b>
     You've told us something we need to review — medication, pregnancy, a medical condition or an allergy not on the list.
     You can complete your order; we'll contact you first and recommend you consult your doctor.</div>`
  : "";

 const tag=$("#fq-tag");
 if(hasVergleich){tag.textContent=`${rabatt}% Rabatt`;tag.style.display="inline-block";}
 else{tag.style.display="none";}
 $("#fq-buyt").textContent=name?`${name}'s Formula`:"Your Personal Formula";
 $("#fq-price").innerHTML=`<span class="now">${eu(F.preis)}</span>`+
   (hasVergleich?`<span class="was">Statt ${eu(F.preisVergleich)}</span><span class="off">Du sparst ${eu(F.preisVergleich-F.preis)}</span>`:"");
 $("#fq-det").textContent=F.detail;

 const keys=rank.slice(0,3).map(p=>p.k);
 let picks=C.upsell.filter(u=>u.bereiche.some(b=>keys.includes(b))).slice(0,C.maxUpsell);
 if(!picks.length)picks=C.upsell.slice(0,C.maxUpsell);
 $("#fq-ul").innerHTML=picks.map(u=>
  `<button class="fq-u" data-u="${u.id}">
   <span class="fq-uc">✓</span>
   ${u.bild?`<img class="fq-uimg" src="${u.bild}" alt="">`:`<span class="fq-uimg fq-uimg--ph"></span>`}
   <span class="fq-ub"><b>${u.name}</b><span>${u.warum}</span></span>
   <span class="fq-upr">${eu(u.preis)}</span></button>`).join("");
 $("#fq-ul").querySelectorAll(".fq-u").forEach(b=>b.addEventListener("click",()=>{
  const id=b.dataset.u;
  st.up.has(id)?st.up.delete(id):st.up.add(id);
  b.classList.toggle("sel",st.up.has(id));recalc();
 }));

 st.plan=true;recalc();
 stage("res");window.scrollTo({top:0});
}

function recalc(){
 let tot=st.plan?F.preis:0;
 st.up.forEach(id=>{const u=C.upsell.find(x=>x.id===id);if(u)tot+=u.preis;});
 $("#fq-tot").textContent=st.plan?eu(tot):"—";
 const cons=["#fq-c1","#fq-c2","#fq-c3","#fq-c4"].every(s=>{var el=$(s);return !el||el.checked;});
 R.querySelector('[data-a="cart"]').disabled=!(st.plan&&cons);
}
R.addEventListener("change",e=>{if(e.target.matches("#fq-c1,#fq-c2,#fq-c3,#fq-c4"))recalc();});


/* --- aggiorna il contatore del carrello nell'header (Dawn e temi simili) --- */
function updateCartBadge(n){
  var sel=[".cart-count-bubble span[aria-hidden]",".cart-count-bubble span",
           "#cart-icon-bubble .cart-count-bubble span","#CartCount",".cart-item-count",
           "[data-cart-count]",".site-header__cart-count",".header__cart-count"];
  var done=false;
  sel.forEach(function(s){
    document.querySelectorAll(s).forEach(function(el){ el.textContent=n; done=true; });
  });
  // se il pallino non esiste ancora (carrello vuoto all'apertura), lo creo
  if(!done){
    var icon=document.querySelector("#cart-icon-bubble, a[href$='/cart'], .header__icon--cart");
    if(icon && n>0 && !icon.querySelector(".cart-count-bubble")){
      var b=document.createElement("div");
      b.className="cart-count-bubble";
      b.innerHTML='<span aria-hidden="true">'+n+'</span>';
      icon.appendChild(b);
    }
  }
}

async function addToCart(){
 const btn=R.querySelector('[data-a="cart"]'),msg=$("#fq-msg");
 btn.disabled=true;btn.textContent="Adding…";
 const props={
  "Formel":st.rank.slice(0,3).map(p=>AREE[p.k].n).join(" · "),
  "Fragebogen":"25/25 answers attached"
 };
 ALL.forEach((q,i)=>{
  const a=st.a[i];
  const key=q.extra?"_★ "+q.lab:"_"+String(i+1).padStart(2,"0")+". "+q.lab;
  props[key]=a?(a.v+(q.unit?" "+q.unit:"")):"—";
 });
 if(st.a.some(a=>a&&a.f))props["_⚠️ REVIEW"]="Yes — contact the customer";

 // normalizza un variantId in intero pulito (evita notazione scientifica, spazi, decimali)
 function vid(x){
   if(typeof x==="number") return Math.round(x);
   var n=String(x).trim().replace(/[^\d]/g,"");   // tiene solo le cifre
   return n?parseInt(n,10):0;
 }
 const items=[{id:vid(F.variantId),quantity:1,properties:props}];
 st.up.forEach(id=>{const u=C.upsell.find(x=>x.id===id);if(u)items.push({id:vid(u.variantId),quantity:1});});

 if(C.demo){FQ_DIRTY=false;
  console.log("FQ — payload for /cart/add.js:",{items});
  msg.className="fq-msg ok";
  msg.textContent="Demo mode. Open the browser console: all answers are there. Set demo: false when you go live.";
  btn.disabled=false;btn.textContent="Add to cart";return;
 }
 try{
  const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items})});
  if(!r.ok)throw new Error(await r.text());
  FQ_DIRTY=false;

  // --- 1. conferma che il prodotto è DAVVERO nel carrello (fino a 5 tentativi) ---
  var count=0;
  for(var attempt=0; attempt<5; attempt++){
    try{
      var cr=await fetch("/cart.js",{headers:{"Accept":"application/json"},cache:"no-store"});
      var cart=await cr.json();
      count=cart.item_count||0;
      if(count>0) break;               // il carrello contiene già l'item: procedi
    }catch(e){}
    await new Promise(function(r){ setTimeout(r,150); });  // aspetta e riprova
  }
  console.log("FQ: carrello confermato, articoli =",count);
  updateCartBadge(count);

  // --- 2. l'app AMP slide-cart è inaffidabile su questo tema (mostra vuoto anche con articoli).
  //         Non apriamo il suo drawer: aggiorniamo il badge e diamo una conferma chiara.
  try{ if(window.Shopify && Shopify.actions && typeof Shopify.actions.cartUpdate==="function") Shopify.actions.cartUpdate(); }catch(e){}
  try{ document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:true})); }catch(e){}
  try{ if(window.jQuery){ jQuery(document.body).trigger("added_to_cart"); } }catch(e){}

  // conferma inline forte: è QUESTA il segnale al cliente (il drawer AMP è inaffidabile)
  msg.className="fq-msg ok fq-added";
  msg.innerHTML=
    '<div class="fq-added-in">'+
      '<span class="fq-added-ic">✓</span>'+
      '<div class="fq-added-tx"><b>Added to your cart'+(count?' ('+count+' item'+(count>1?"s":"")+')':'')+'</b>'+
        '<span>You can add more products or go straight to checkout.</span></div>'+
      '<a class="fq-added-btn" href="/cart">Go to cart →</a>'+
    '</div>';
  msg.scrollIntoView({behavior:"smooth",block:"center"});
  btn.textContent="Added ✓";
  setTimeout(function(){ btn.disabled=false; btn.textContent="Add to cart"; }, 1500);
 }catch(e){
  console.error(e);
  msg.className="fq-msg err";
  var det=(e&&e.message)?String(e.message):"";
  try{ var j=JSON.parse(det); det=(j.description||j.message||det); }catch(_){}
  msg.textContent="Could not be added. "+(det?("Shopify: "+det.slice(0,220)):"Bitte erneut versuchen.");
  console.error("FQ add-to-cart error:", e);
  btn.disabled=false;btn.textContent="Add to cart";
 }
}

R.addEventListener("click",e=>{
 const b=e.target.closest("[data-a]");if(!b)return;
 const a=b.dataset.a;
 if(a==="start"){FQ_DIRTY=true;stage("quiz");render();radar();window.scrollTo({top:0});}
 if(a==="back"&&st.i>0){st.i--;render();}
 if(a==="next")next();
 if(a==="pick"){$("#fq-c1").scrollIntoView({behavior:"smooth",block:"center"});}
 if(a==="cart")addToCart();
 if(a==="restart"){FQ_DIRTY=false;location.reload();}
});
/* --- Avviso prima di ricaricare/uscire mentre il quiz è in corso --- */
window.addEventListener("beforeunload",function(e){
  if(FQ_DIRTY){ e.preventDefault(); e.returnValue=""; return ""; }
});
document.addEventListener("keydown",e=>{
 if(!R.querySelector('[data-s="quiz"]').classList.contains("on"))return;
 const q=ALL[st.i];
 if(q.type==="ch"&&/^[1-9]$/.test(e.key)){
  const b=$("#fq-q").querySelector(`.fq-opt[data-k="${+e.key-1}"]`);if(b)b.click();
 }
 if(e.key==="Enter"&&!R.querySelector('[data-a="next"]').disabled)R.querySelector('[data-a="next"]').click();
});
})();